import useEnv from '../composables/useEnv'
import usePlan from '../composables/usePlan'
import useRestNode from '../composables/useRestNode'

export default function useBenefits(profile, context) {

    const { get } = useRestNode()
    const { benefitEndpoint } = useEnv()

    const getCoverage = () => {
        const { getPlan } = usePlan(profile, context)
        const plan = getPlan()
        return getPlan().coverageInfo
    }

    const getBenefitCategories = async (term) => {
        let result = {}
        const coverage = getCoverage()
        try {
            const url = `${benefitEndpoint}/category/search/${coverage.groupNumber}/${coverage.siteNumber}/${coverage.packageCode}/${encodeURIComponent(term)}`
            //console.log('benefit category url:', url.toString())
            result = await get(url)
        } catch (error) {
            console.log(error)
        }
        return result.value
    }

    const getBenefitDetail = async (category) => {
        let result = {}
        const coverage = getCoverage()
        try {
            const url = `${benefitEndpoint}/detail/${coverage.groupNumber}/${coverage.siteNumber}/${coverage.packageCode}/${encodeURIComponent(category)}`
            //console.log('benefit detail url:', url.toString())
            result = await get(url.toString())
        } catch (error) {
            console.log(error)
        }
        return result.value
    }

    /**
     * Returns benefit information for a given search.
    */
        const getBenefitInfoForSearch = async () => {
          const validTypes = {
            "urgent": "urgent care",
            "medical": "office visits",
            "hospital:1": "hospital"
          }
   
          if(profile.isAuthenticated && (context.term || Object.keys(validTypes).includes(context.type))) {
            try {
              return await getBenefitCategories(context.term || validTypes[context.type])
            }
            catch (error) {
              console.log(error)
              return null
            }
          }
          return null
        }

    return { getBenefitCategories, getBenefitDetail, getBenefitInfoForSearch, getCoverage }
}